import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useQuickEdit } from '@/hooks/useQuickEdit';
import { useHomepageSectionMutation } from '@/hooks/useHomepageSectionMutation';
import QuickEditInline from '@/components/quickedit/QuickEditInline';

interface BannerProps {
  section: any;
}

export default function Banner({ section }: BannerProps) {
  const content = section.content ?? {};
  const bgColor = content.bg_color || 'bg-sage-700';
  const ctaText = content.cta_text;
  const ctaLink = content.cta_link;

  const { isActive } = useQuickEdit();
  const mutation = useHomepageSectionMutation(section.id);

  return (
    <section className={`${bgColor} text-white`}>
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8 text-center">
        {section.title && (
          <h2 className="font-display text-2xl font-bold sm:text-3xl">
            {isActive ? (
              <QuickEditInline
                value={section.title}
                onSave={(val) => mutation.mutateAsync({ title: val, content: section.content })}
                label="Banner title"
                as="span"
                className="font-display text-2xl font-bold sm:text-3xl text-white"
              />
            ) : section.title}
          </h2>
        )}
        {section.subtitle && (
          <p className="mt-2 text-white/80 max-w-xl mx-auto">
            {isActive ? (
              <QuickEditInline
                value={section.subtitle}
                onSave={(val) => mutation.mutateAsync({ subtitle: val, content: section.content })}
                label="Banner subtitle"
                as="span"
                className="text-white/80"
              />
            ) : section.subtitle}
          </p>
        )}
        {ctaText && ctaLink && (
          <Link
            to={ctaLink}
            className="mt-4 inline-flex items-center gap-2 rounded-lg bg-white/20 px-6 py-2.5 text-sm font-medium text-white hover:bg-white/30 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            {ctaText}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        )}
      </div>
    </section>
  );
}
